import type { ComponentRenderProps } from "@json-render/react";
import { z } from "zod";

import { ReportFooter } from "./ReportFooter";

const PLACEHOLDER_DISCLAIMER =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";

/** Layout Studio catalog definition for ReportFooter. */
export const ReportFooterSpec = {
  props: z.object({
    /** Optional legal or distribution disclaimer; omit or null when not needed. */
    disclaimer: z.string().nullable().optional(),
  }),
  description:
    "Report page footer. disclaimer is optional — the preview displays Lorem ipsum placeholder copy when omitted or null. When the user provides text, copy it verbatim into disclaimer. Page numbers are added by the preview — do not set pageIndex or totalPages.",
  example: {
    disclaimer:
      "For internal use only. Not for external distribution without approval.",
  },
} as const;

type ReportFooterPropsFromSpec = {
  disclaimer?: string | null;
  pageIndex?: number | null;
  totalPages?: number | null;
  /** @deprecated Legacy glean layouts used `text` instead of `disclaimer`. */
  text?: string | null;
  /** Preview-only; `false` renders an empty disclaimer instead of placeholder copy. */
  showPlaceholder?: boolean;
};

const resolveStudioFooterDisclaimer = (
  props: ReportFooterPropsFromSpec,
): string => {
  const raw = props.disclaimer ?? props.text;
  if (typeof raw === "string" && raw.trim() !== "") return raw;
  return props.showPlaceholder === false ? "" : PLACEHOLDER_DISCLAIMER;
};

/** Adapter for json-render defineRegistry: renders ReportFooter from catalog props. */
export const ReportFooterFromProps = ({ element }: ComponentRenderProps) => {
  const props = element.props as ReportFooterPropsFromSpec;
  return (
    <ReportFooter
      disclaimer={resolveStudioFooterDisclaimer(props)}
      pageIndex={props.pageIndex ?? undefined}
      totalPages={props.totalPages ?? undefined}
    />
  );
};
